import React from 'react';
import { Select } from 'vendors/semantic-ui';
import { DressSortListProps, DressSortType, DressSortTypeValues } from '.';
import { Sort } from '../../../shared/models';

const sort: Sort<DressSortType>[] = [
    {
        text: 'Trier par',
        value: 0,
    },
    {
        text: 'Prix croissant',
        value: 1,
    },
    {
        text: 'Prix décroissant',
        value: 2,
    },
    {
        text: 'Nom',
        value: 3,
    },
];

export const DressSortList: React.FC<DressSortListProps> = ({
    selectedValue,
    handleSortSelection,
}: DressSortListProps) => {
    const localSelectedValue = selectedValue || DressSortTypeValues.UNKNOWN;
    return (
        <Select
            className="custom-selector"
            placeholder="Trier par"
            value={localSelectedValue}
            options={sort}
            onChange={(_e, data) => {
                if (localSelectedValue !== data.value) {
                    handleSortSelection(data.value as DressSortType);
                }
            }}
        />
    );
};
